"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAmounts = void 0;
/**
 * Validates that all amount values are positive, otherwise it throws an error.
 */
const validateAmounts = (amounts) => {
    const hasNegativeAmounts = amounts.some((value) => value < 0);
    if (hasNegativeAmounts) {
        throw new Error("All amount values should be positive");
    }
};
exports.validateAmounts = validateAmounts;
//# sourceMappingURL=utils.js.map